
namespace RioERP.Invoices {
    export class InvoiceNumberFormatColumns {
        static columnsKey = 'Invoices.InvoiceNumberFormat';
    }
}